import useHandleError from "@Errors/hooks/useHandleError";
import {useEffect} from "react";

export default function useHandleAmenitiesUpdateError(response: any, openErrorModal: () => void) {
    const {setError} = useHandleError()

    useEffect(() => {
        if (response.isError) {
            openErrorModal()
            setError("amenities broke")
        }
    }, [response]);
}